/**
 * freePick — the two client predicates of a house's free first pick (plan
 * `2026_10_25_toile_first_take_free.md` § 2, § 7), pure so `Wall.tsx` imports them rather than inlining
 * the booleans. The server holds the allowance (`HouseAdapter.freePick`); the client only knows whether
 * the reader already holds a take of their own, which is what a spent pick looks like from here.
 */
import type {MineResponse} from '@core/wall/contract'
import type {HouseTheme} from './theme'

/** A signed-out reader whose first Generate may write: the house declares a pick and the reader holds no
 *  take yet. Once `mine` holds one the pick is spent and the next Generate opens the card with no round trip. */
export function freePickOpen(theme: Pick<HouseTheme, 'freePick'>, signedIn: boolean, mine: MineResponse | null): boolean {
    return !signedIn && theme.freePick === true && mine === null
}

/** The reader owns rows on the wall: a member, or a visitor holding a free take. Drives `/mine`'s polls, the
 *  arrival stamps, the chain history and the doors. */
export function ownsRows(signedIn: boolean, mine: MineResponse | null): boolean {
    return signedIn || mine !== null
}
